import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 * 实战列表
 * @param params
 * 
*/

export const practiceList = params => Http.get(`${baseUrl}/works/task`, { params })

/**
 * 实战信息
 * @param taskId
 * 
*/

export const practiceInfo = taskId => Http.get(`${baseUrl}/works/task/${taskId}` )
